import { createContext } from 'react';

export type PageContextType = {
  setTitle: (title: string) => void;
};

export const PageContext = createContext<PageContextType>({
  setTitle: () => {},
});
